export const TRUNCATE_LENGTH_DEFAULT = 8;

export function truncateText(text: string, length = TRUNCATE_LENGTH_DEFAULT) {
    return text.length > length ? text.slice(0, length) + "…" : text;
}

export function hasWhiteSpace(s: string) {
    return /\s/g.test(s);
}

export function isValidJsonString(str = "") {
    try {
        JSON.parse(str);
        return true;
    } catch {
        return false;
    }
}

export function addSpaceBetweenChars(str: string) {
 return str?.split('').map(char => char + ' ').join('').trim() || "";
}

export function insertNewlines(str: string, maxLength: number, maxBreakLines = 1): string {
    let result = '';
    let currentLineLength = 0;
    let lineBreaks = 0;
    const words = str.split(' ');

    for (const word of words) {
        if (currentLineLength + word.length + 1 > maxLength) {
            if (maxBreakLines !== undefined && lineBreaks >= maxBreakLines) {
                result += '...';
                break;
            }
            result += '\n';
            lineBreaks++;
            currentLineLength = 0;
        } else if (result.length > 0) {
            result += ' ';
        }
        result += word;
        currentLineLength += word.length + 1;
    }
    return result;
}
